import { GeoJSONFeature } from "mapbox-gl";
import * as turf from "@turf/turf";
import { LineString, Point } from "geojson";
import { determineSideAndDistance } from "./determineSideAndDistance";

export const processLineStringAdjacentFeature = (
  mainLine: LineString,
  breakPoint: Point,
  feature: GeoJSONFeature,
) => {
  var linesToCheck: LineString[] = [];
  if (feature.geometry.type === "LineString") {
    linesToCheck = [feature.geometry];
  } else if (feature.geometry.type === "MultiLineString") {
    linesToCheck = feature.geometry.coordinates.map(
      (x) => turf.lineString(x).geometry,
    );
  }

  const result: Record<"right" | "left", number> = {
    left: Infinity,
    right: Infinity,
  };

  for (const otherLine of linesToCheck) {
    const pointInOtherLine = turf.nearestPointOnLine(otherLine, breakPoint);

    const sideAndDistance = determineSideAndDistance(
      pointInOtherLine.geometry,
      mainLine,
    );

    if (sideAndDistance && sideAndDistance.distance > 0) {
      result[sideAndDistance.side] = Math.min(
        sideAndDistance.distance,
        result[sideAndDistance.side],
      );
    }
  }

  return result;
};
